


















































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel,DraggerImg, PaginationPanelDay,PaginationPanelThan } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { fmoney } from '@/common/util/money';
import { enums } from '@/common/enums';
import { WorkingTable, Area } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
        PaginationPanelDay,
        PaginationPanelThan
    },
})
export default class DataAnalysis extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
      flexColumnWidthArray(str, tableData, flag = 'max') {
        console.log('tableData', tableData);
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            let indexy = 0;
            for (let i = 0; i < tableData.length; i++) {
                for (let j = 0; j < tableData[i].orderList.length; j++) {
                    if (tableData[i].orderList[j] === null) {
                        continue;
                    }
                    const now_temp = tableData[i].orderList[j][str] + '';
                    const max_temp = tableData[index].orderList[indexy][str] + '';
                    console.log('valllll->', tableData[i].orderList[j], i, j, tableData[i].orderList[j][str], index, indexy);
                    if (now_temp.length > max_temp.length) {
                        index = i;
                        indexy = j;
                    }
                }
                // if (tableData[i][str] === null) {
                //     return;
                // }
                // const now_temp = tableData[i][str] + '';
                // const max_temp = tableData[index][str] + '';
                // if (now_temp.length > max_temp.length) {
                //     index = i;
                // }
            }
            console.log('yunhuanjies', index, indexy);
            columnContent = tableData[index].orderList[indexy][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 150) {
            // 设置最小宽度
            flexWidth = 150;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public activeName = 'first';
    public fmoney = fmoney;
    //public stateType2 = enums.stateType2;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public moreThanVisible = false;
    public async exportExcel() {
        // let data = await ProjectInquiry.Export(this.searchValue);
    }

    public searchValue: any = {
        interfaceType: '',
        success: '',
        startCreationTime: '',
        endCreationTime: '',
        identifyNumber: '',

        orderBy: '',
        ASC: true,
    };
    public searchValueDay:any = {
        interfaceType: '',
        success: '',
        startCreationTime: '',
        endCreationTime: '',
        identifyNumber: ''
    }
     public moreThanValue = {
         shipperId:'',
         carrierId:'',
         carrierOrderCode:'',
         shipOrderNo:'',
         consignee:'',
         creationStartTime:'',
         creationEndTime:'',
         realDeliveryStartTime:'',
         realDeliveryEndTime:'',
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    public async DataAnalysisExport() {
        await WorkingTable.DataAnalysisExport(this.searchValue);
        this.$message.success('导出成功!');
    }
    public async DayAnalysisExport() {
        await WorkingTable.DataAnalysisExport(this.searchValue);
        this.$message.success('导出成功!');
    };

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('crud1', JSON.stringify(this.colData));
    }

     public colData = JSON.parse(localStorage.getItem('crud1'))
        ? JSON.parse(localStorage.getItem('crud1'))
        : [
              { title: '发货方', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '含税金额', isShow: true, disabled: false },
              { title: '及时率', isShow: true, disabled: false },
              { title: '超48H发货', isShow: true, disabled: false },
          ];
    public time1:any = []
    // 日报表订单时间改变
    public orderDatetimerange(v) {
       if(v){
           this.searchValue.startCreationTime = v[0];
           this.searchValue.endCreationTime = v[1];
       }
       else {
           this.searchValue.startCreationTime = null;
          this.searchValue.endCreationTime = null;
       }
    }

    public time2:any = []
    // 日报表订单时间改变
    public orderDatetimerange1(v) {
        if(v){
            this.searchValueDay.startCreationTime = v[0];
            this.searchValueDay.endCreationTime = v[1];
        }
        else {
            this.searchValueDay.startCreationTime = null;
            this.searchValueDay.endCreationTime = null;
        }
    }

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        paginationDay:HTMLFormElement;
        paginationThan:HTMLFormElement;
        multipleTable: HTMLFormElement;
        multipleTableDay:HTMLFormElement;
        multipleThanTable:HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public handleClose(){
        this.moreThanVisible = false;
    }
    public searchFunc() {
        sessionStorage.setItem('crud1_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public searchFuncDay(){
        sessionStorage.setItem('crud1_searchValueDay', JSON.stringify(this.searchValueDay));
        this.$refs.paginationDay.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public resetSearchValue() {
        this.time1 = [];
        this.searchValue = {
            interfaceType: '',
            success: '',
            startCreationTime: '',
            endCreationTime: '',
            identifyNumber: '',
            orderBy: '',
            ASC: true,
        };
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.loadData();
        sessionStorage.setItem('crud1_searchValue', JSON.stringify(this.searchValue));
    }
    public resetSearchValueDay(){
        this.time2 = [];
        this.searchValueDay = {
            interfaceType: '',
            success: '',
            startCreationTime: '',
            endCreationTime: '',
            identifyNumber: '',
            orderBy: '',
            ASC: true,
        }
        this.$refs.multipleTableDay.clearSort();
        this.$refs.paginationDay.resetSize();
        this.$refs.paginationDay.handleSizeChange(10);
        this.loadDataDay();
        sessionStorage.setItem('crud1_searchValueDay', JSON.stringify(this.searchValueDay));
    }
    public interfaceType1 = enums.interfaceType1;
    public interfaceType2 = enums.interfaceType2;
    public succcess = enums.succcess;
    public expandType: boolean = false;
    public loading = false;
    public loadingDay = false;
    public rePagin = false;
    public rePaginDay = false;
    public total = 20;
    public totalDay = 20;
    public isActive: boolean = false;
    public isActive1: boolean = false;
    public tableData: any = [];
    public tableDataDay:any = [];
    public handleClick(val){

    }
    public async loadData() {
        this.loading = true;
        try {
            let res = await WorkingTable.GetReceiveLogList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            // if (res.data && res.data.length > 0) {
            //     res.data.forEach((i) => {
            //         i.totalFeeAmount = fmoney(i.totalFeeAmount, 2, false);
            //     });
            // }
            this.tableData = res.data;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            let skip = this.searchPagin.skip;
            //this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
    public async loadDataDay(){
       this.loadingDay = true;
       try {
          let res = await WorkingTable.GetSendLogList({
              ...this.searchValueDay,
               skip: this.searchPaginDay.skip,
               count: this.searchPaginDay.count,
          });
          this.tableDataDay = res.data;
          this.$refs.paginationDay.setNowPage(this.searchPaginDay.count);
          this.$refs.paginationDay.setPage(this.searchPaginDay.currentPage);
          let skip = this.searchPaginDay.skip;
          this.tableDataDay.map((item, index) => {
                item.index = skip++ + 1;
          });
          this.totalDay = res.total;
          this.loadingDay = false;
       }
       catch {
          this.loadingDay = false;
       }
    }

    public created() {}

    currentdate = '';
    currentdate2 = '';

    public originProvinceStr = '';
    public arrivalProvinceStr = '';

    public provinceArray: any = [];
    async getProvince() {
        let area = await Area.area();
        this.provinceArray = area.data;
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        this.getProvince();
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month: any = date.getMonth() + 1;
        var strDate: any = date.getDate();
        if (month >= 1 && month <= 9) {
            month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = '0' + strDate;
        }
        this.currentdate = year + seperator1 + month + seperator1 + '01 ' + '00:00:00';
        this.currentdate2 = year + seperator1 + month + seperator1 + strDate + ' 23:59:59';
        // this.searchValue.realDeliveryStartTime = this.currentdate;
        // this.searchValue.realDeliveryEndTime = this.currentdate2;
        this.searchValue.deliveryStartTime = this.currentdate;
        this.searchValue.deliveryEndTime = this.currentdate2;

        if (sessionStorage.getItem('crud1_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('crud1_searchValue'));
            console.log(' this.searchValue  ' + JSON.stringify(this.searchValue));
            this.searchPagin = sessionStorage.getItem('crud1_page')
                ? JSON.parse(sessionStorage.getItem('crud1_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('crud1_page')
                ? JSON.parse(sessionStorage.getItem('crud1_page'))
                : this.searchPagin;

            this.loadData();
        }
        if(sessionStorage.getItem('crud1_searchValueDay')){
            this.searchValueDay = JSON.parse(sessionStorage.getItem('crud1_searchValueDay'));
            this.searchPaginDay = sessionStorage.getItem('crud1_page_Day')
            ? JSON.parse(sessionStorage.getItem('crud1_page_Day'))
            : this.searchPaginDay;

            this.loadDataDay();
        }
        else {
            this.searchPaginDay = sessionStorage.getItem('crud1_page_Day')
            ? JSON.parse(sessionStorage.getItem('crud1_page_Day'))
            : this.searchPaginDay;

            this.loadDataDay();
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public searchPaginDay:Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('crud1_page', JSON.stringify(pagin));
        this.loadData();
    }
    public onPaginationChangeDay(pagin:Pagination){
        this.searchPaginDay = pagin;
        sessionStorage.setItem('crud1_page_Day',JSON.stringify(pagin));
        this.loadDataDay();
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'contactName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'contactPhone':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'score':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
            case 'enabled':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 5;
                }
                break;
        }
        this.loadData();
    }
    getStrWithSimonFromNum(num) {
        let numstr = num.toString();
        let arr = numstr.split('.');
        if (arr.length > 1) {
            return arr[0].toString().includes('-')
                ? '-' +
                      arr[0]
                          .toString()
                          .split('')
                          .reverse()
                          .join('')
                          .match(/\d{1,3}/g)
                          .join(',')
                          .split('')
                          .reverse()
                          .join('') +
                      '.' +
                      arr[1]
                : arr[0]
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                      .match(/\d{1,3}/g)
                      .join(',')
                      .split('')
                      .reverse()
                      .join('') +
                      '.' +
                      arr[1];
        } else {
            return arr[0].toString().includes('-')
                ? '-' +
                      arr[0]
                          .toString()
                          .split('')
                          .reverse()
                          .join('')
                          .match(/\d{1,3}/g)
                          .join(',')
                          .split('')
                          .reverse()
                          .join('')
                : arr[0]
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                      .match(/\d{1,3}/g)
                      .join(',')
                      .split('')
                      .reverse()
                      .join('');
        }
    }
}
